import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSupervisorAuth } from '../context/SupervisorAuthContext';
import LoadingScreen from './LoadingScreen';

const RequireSupervisorAuth = () => {
  const { supervisor, loading } = useSupervisorAuth();

  if (loading) return <LoadingScreen />;
  if (!supervisor) return <Navigate to="/login" replace />;

  return <Outlet />;
};

export default RequireSupervisorAuth;
